import { computed } from "vue";
import {
    accountHolderRule,
    accountNumberRule,
    bankNameRule,
    branchRule,
    directDebitDayRule,
    postcodeRule,
    sortCodeRule,
} from "@/validation";

export const bankDetailsRules = () =>
    computed(() => ({
        accountNumber: accountNumberRule,
        sortCode: sortCodeRule,
        bankName: bankNameRule,
        branch: branchRule,
        directDebitDay: directDebitDayRule,
        accountHolder: accountHolderRule,
        address: {
            postcode: postcodeRule,
        },
    }));
